import VALID_UUID_REGEX from '@studio/constants/uuid';

export const isValidUuid = (uuid: string) => {
  if (typeof uuid !== 'string') {
    return false;
  }
  return VALID_UUID_REGEX.test(uuid);
};
